import { render, staticRenderFns } from "./authGroupUser.vue?vue&type=template&id=20670981"
import script from "./authGroupUser.vue?vue&type=script&lang=js"
export * from "./authGroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20670981')) {
      api.createRecord('20670981', component.options)
    } else {
      api.reload('20670981', component.options)
    }
    module.hot.accept("./authGroupUser.vue?vue&type=template&id=20670981", function () {
      api.rerender('20670981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/auth/authGroupUser.vue"
export default component.exports